import { useQuery } from '@apollo/client';
import { memo } from 'react';

import { filesClient as client } from '@uptime/controller/src/apolloClientConfiguration';
import UserAvatar from '@uptime/shared/components/UserAvatar';
import { getProfileFileUrl } from '@uptime/shared/graphql/documents';

interface Props {
  userId: number;
  userName: string;
  isLoaded?: boolean;
  [key: string]: any;
}

const TechnicianAvatar = ({ userId, userName, isLoaded, ...other }: Props) => {
  const { loading, data: { url } = {} } = useQuery(getProfileFileUrl, {
    variables: {
      userId,
    },
    client,
    skip: isLoaded,
  });

  return <UserAvatar isLoading={!isLoaded && loading} src={url} name={userName} {...other} />;
};

export default memo(TechnicianAvatar, (prevProps, nextProps) => {
  const { userId: prevUserId } = prevProps;
  const { userId: nextUserId } = nextProps;

  return prevUserId === nextUserId;
});
